var React = require('react');
var StatsTable = require('./StatsTable.jsx');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');

var Whistles = React.createClass({
    render : function(){
        var whistles = [];
        var colors = this.props.colors || ["#ffc300", "#d31346"];
        var count = Number(this.props.count) || 0;
        var team = this.props.team;
        
        for (var i = 0; i < count; i++) {
            whistles.push(
                <span key={team + i} className="icon-font countIcon" style={{"color": team === 'home' ? colors[0] : colors[1]}}>{'<'}</span>
            );
        }
        return (
            <div className="countIcons">
                {whistles}
            </div>
        );
    }
});

var Discipline = React.createClass({
    render : function(){
        
        return (
            <article className="sub-module" style={{overflow:'auto'}}>
				<header className="bordered">
					<h1>Discipline</h1>
				</header>
				<div className="stacked-rl">
                    
					<div className="col-a content">
                        <TeamCompareHeader heading="Penalties conceded" home={this.props.home} away={this.props.away} />
                            
                        <div className="countChart">
                            <div className="home">
                                <div className="countLabel">{this.props.pensConceded.home.total}</div>
                                <Whistles colors={this.props.colors} team="home" count={this.props.pensConceded.home.total} />
                            </div>
                                    
                            <div className="away"><div className="countLabel">{this.props.pensConceded.away.total}</div>
                                <Whistles colors={this.props.colors} team="away" count={this.props.pensConceded.away.total} />
                            </div>
                        </div>	
        			</div>
                    
        			<div className="col-b content">
                        <TeamCompareHeader bordered="bordered" home={this.props.home} away={this.props.away} />
                        <StatsTable stats={this.props.disciplineStats} />
        			</div>
    			</div>
    		</article>
        );
    }
});

module.exports = Discipline;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/Discipline.jsx
 **/